export default "__VITE_PUBLIC_ASSET__f40a06a0__"